import { useEffect, useState } from "react";
import PopUp from "./ReactPortal/PortalPopUp";
import SizeGuide from "../common/SizeGuide";
import { useDispatch } from "react-redux";
import { setSidebarWidth } from "../../redux/actions/generalAction";
import JewelrySizeGuide from "./JewelrySizeGuide";
export default function SizeGuidePopUp( props ) {
  const {sizeGuideType, className = ''} = props
  const dispatch = useDispatch();
  const [visibility, setVisibility] = useState(false);
  const popupCloseHandler = (e) => {
    setVisibility(false);
    // dispatch(setSidebarWidth(false));
  };
  useEffect(() => {
    if (visibility) {
      document.body.classList.add("disable-sizeguide-scroll")
    }
    else {
      document.body.classList.remove("disable-sizeguide-scroll")
    }
  })
    
  return (
    <>
    {sizeGuideType == 'Rings' ? (<span className="hover"><a href="/Olivela_Ring_Size_Guide.pdf" tabindex={0} download="Olivela_Ring_Size_Guide.pdf" className={`download-ring-size-guide ${className ? className : null} brdr_btm_0 ${props?.plp == true ? "ga4-ring-size-guide-plp" : props?.pdp == true ? "ga4-ring-size-guide-pdp" : ""}`}>
           Download ring size guide 
      </a></span>):(
          //classname ga4-size-guide to be always added at the last of the classname values as the regex is used in GTM to track the dynamic size guide.
        // If new classname is required please add it before that.
        <span tabIndex={0} className={`${visibility} ${className ? className : null} hover ${props?.plp == true ? `ga4-size-guide-plp-${sizeGuideType}` : props?.pdp == true ? `ga4-size-guide-pdp-${sizeGuideType}` : ""}`} onClick={(e) => {
          e.preventDefault();
          e.stopPropagation(); 
          setVisibility(true);
        }}>
        Size Guide
      </span>)}
      { visibility &&
      <PopUp onClose={popupCloseHandler} show={visibility} isClose={props.isClose} wrapperClass={`size-guide-popup ${sizeGuideType == 'Necklaces' ? 'wider': ''}`}>
      {sizeGuideType == 'Necklaces' ? (
        <JewelrySizeGuide sizeGuideType={sizeGuideType}/>
        ) :
        (<SizeGuide sizeGuideType={sizeGuideType} />)
      }     
    </PopUp>}
    </>
  );
}
